import {RWSService} from '@rws-framework/client';
import type {RosterRecord} from "../types/users";
import type {Activity} from "../types/activities";
import CourseDashboardService, {type CourseDashboardServiceInstance} from './CourseDashboardService';
import StorageService, {type StorageServiceInstance} from './StorageService';
import InsightsDashboardService, {type InsightsDashboardServiceInstance} from './InsightsDashboardService';
import type { Course } from 'src/components/programs/typesRaw';

class EventsService extends RWSService {
  static defaultEventOptions = {
    bubbles: true,
    composed: true,
    cancelable: true
  }

  constructor(
    @CourseDashboardService private dashboardService: CourseDashboardServiceInstance,
    @StorageService private storageService: StorageServiceInstance,
    @InsightsDashboardService private insightsDashboardService: InsightsDashboardServiceInstance,
  ) {
    super();
  }

  _dispatch(type: string, detail?: object, options?: object) {
    return document.documentElement.dispatchEvent(new CustomEvent(type, Object.assign(Object.assign({
      detail
    }, EventsService.defaultEventOptions), options)));
  }

  getAverage(gradebook: boolean = false, activity_id: string | null = null): Promise<any> {
    const options = {
      ...(gradebook ? { gradebook: true } : {}),
      ...(activity_id ? { activity_id } : {})
    }
    return this.dashboardService.get('average-score', options)
  }

  getStudentAverage(): Promise<any> {
   return this.insightsDashboardService.get("gradebook", {'no_custom_rollup': true});
  }

  getActivityManager(): Promise<any[]> {
    return this.dashboardService.get('activity_manager');
  };

  getActivities(): Promise<Activity[]> {
    return this.dashboardService.get('activities');
  };

  getMongoId(): Promise<string> {
    return this.storageService.get('prop', 'mongoId')
  };

  getRoster(): Promise<RosterRecord[]> {
    return this.dashboardService.get('students');
  };

  getLTIStuff(): Promise<any> {
    return this.dashboardService.get('ltiStuff');
  };

  getCourse(): Promise<Course> {
    return new Promise((resolve, reject) => {
      this.storageService.get("course",{ courseId: window.stateParams.courseId }, (course) => {
        if (course) {
          resolve(course);
        } else {
          reject(new Error("Course not found"));
        }
      })
    })
  };

  getCalendarMode(): Promise<any> {
    return new Promise((resolve) => {
      this._dispatch('jnct:getCalendarMode', (data: any) => {
        resolve(data)
      })
    })
  };

  //course id from dashboard service
  getServiceCourseId(): string {
    return this.dashboardService.courseId;
  };

  getCourseMode(course_id: string): string {
    if (!course_id) {
      sessionStorage.setItem('mode', '');
      return "presentation";
    };
    const mode = sessionStorage.getItem('mode');
    if (mode?.includes(course_id)) {
      return mode.replace(course_id, '');
    };
    sessionStorage.setItem('mode', course_id + "presentation");
    return "presentation";
  };
}

export default EventsService.getSingleton()

export {EventsService as EventsServiceInstance}
